class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    const closeButton = this.querySelector('.mobile-facets__close');
    if (closeButton) {
      closeButton.addEventListener('click', this.onCloseButtonClick.bind(this));
    }
    this.querySelector('.desktop_apply_button')?.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault(); // Prevents page scrolling on Space
        this.click();
      }
    });

  }

  onCloseButtonClick(event) {
    event.preventDefault();
    const menuDrawer = this.closest('menu-drawer');
    if (menuDrawer && menuDrawer.closeMenuDrawer) {
      menuDrawer.closeMenuDrawer(event);
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.updateFilterCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.updateFilterCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    const parser = new DOMParser();
    const parsedHtml = parser.parseFromString(html, 'text/html');
    const productGridContainer = document.getElementById('ProductGridContainer');
    productGridContainer.innerHTML = parsedHtml.getElementById('ProductGridContainer').innerHTML;

    let target = productGridContainer.querySelector('#infinite-scroll-target');
    if (!target) {
      target = document.createElement('div');
      target.id = 'infinite-scroll-target';
      productGridContainer.appendChild(target);
    }

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    initializeAccordion();
    updateBannerHeight();
    initInfiniteScroll();
    const containers = document.querySelectorAll('.mobile-facets__main, .facets-container-drawer .facets-pill');
    containers.forEach(container => {
      enableDragScroll(container);
    });
    handleFacetFilters();
    setTimeout(async () => {
      const savedPage = parseInt(sessionStorage.getItem("infPage") || "1");
      const savedScroll = parseInt(sessionStorage.getItem("infScrollY") || "0");

      if (savedPage <= 1) return;

      infinitePage = 1;
      window.isRestoring = true;

      for (let i = 1; i < savedPage; i++) {
        await loadNextPageManual();
      }

      window.isRestoring = false;

      // wait for layout to settle
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          window.scrollTo(0, savedScroll);
        });
      });
    }, 100);

  }

  static loadNextPageManual() {
    return new Promise((resolve) => {
      const grid = document.querySelector('.product-grid');
      const target = document.querySelector('#infinite-scroll-target');

      if (!grid || !target) return resolve();

      const initialCount = grid.children.length;

      const observer = new MutationObserver(() => {
        const newCount = grid.children.length;

        if (newCount > initialCount) {
          observer.disconnect();
          infinitePage += 1;
          resolve();
        }
      });

      observer.observe(grid, { childList: true });

      target.scrollIntoView({ block: 'end' });

      setTimeout(() => {
        observer.disconnect();
        resolve();
      }, 5000);
    });
  }


  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }
        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateFilterCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const activeFacets = parsedHTML.querySelectorAll('.js-facet-remove');
    const count = activeFacets.length;
    const applyButtons = document.querySelectorAll('.desktop_apply_button');
    applyButtons.forEach(button => {
      const countSpan = button.querySelector('.filter-count');
      if (count > 0) {
        if (!countSpan) {
          const span = document.createElement('span');
          span.className = 'filter-count';
          span.textContent = ` (${count})`;
          button.appendChild(span);
        } else {
          countSpan.textContent = ` (${count})`;
        }
      } else {
        if (countSpan) countSpan.remove();
      }
    });
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    sessionStorage.removeItem("infScrollY");
    sessionStorage.removeItem("infPage");
    infinitePage = 1;

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';
    const currentSortInput = event.target.closest('input[name="sort_by"]');

    // If the event is triggered by a sort_by checkbox
    if (currentSortInput && currentSortInput.name === 'sort_by') {
      // Uncheck all other sort_by checkboxes
      document.querySelectorAll('input[name="sort_by"]').forEach((input) => {
        if (input !== currentSortInput) {
          input.checked = false;
        }
      });
    }

    const forms = [];
    sortFilterForms.forEach((form) => {
      if (!isMobile) {
        if (
          form.id === 'FacetSortForm' ||
          form.id === 'FacetFiltersForm' ||
          form.id === 'FacetSortDrawerForm'
        ) {
          forms.push(this.createSearchParams(form));
        }
      } else if (form.id === 'FacetFiltersFormMobile') {
        forms.push(this.createSearchParams(form));
      }
    });

    // Combine all form data, ensuring only one sort_by is included
    const combinedParams = forms.join('&');
    this.onSubmitForm(combinedParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

function initializeAccordion() {
  const mediaQuery = window.matchMedia('(max-width: 768px)');
  let openAccordionId = null;
  const detailsElement = document.querySelector('.mobile-facets__disclosure');
  const summaryElement = detailsElement?.querySelector('summary');
  const nextElement = summaryElement?.nextElementSibling;

  // Store the ID of the currently open accordion before DOM updates
  function saveOpenAccordionState() {
    const openContainer = document.querySelector('.filter_header + [style*="max-height"][style*="0px"]');
    openAccordionId = openContainer ? openContainer.previousElementSibling.id : null;
  }

  function closeAllAccordions(excludeHeader = null) {
    const filterHeaders = document.querySelectorAll('.filter_header');
    filterHeaders.forEach(header => {
      if (header === excludeHeader) return;
      const container = header.nextElementSibling || header.closest('.js-filter')?.querySelector('.filter_container_inner');
      if (!container) return;
      const icons = header.querySelectorAll('.svg-wrapper');
      if (icons.length < 2) return;
      container.style.maxHeight = '0px';
      container.classList.remove('open');
      container.style.visibility = 'hidden';
      icons[0].style.display = 'inline-block';
      icons[1].style.display = 'none';
    });
  }

  function toggleAccordion(header) {
    if (!mediaQuery.matches) return;
    const container = header.nextElementSibling || header.closest('.js-filter')?.querySelector('.filter_container_inner');
    if (!container) return;
    const icons = header.querySelectorAll('.svg-wrapper');
    if (icons.length < 2) return;
    const isOpen = container.style.maxHeight && container.style.maxHeight !== '0px';
    
    // Get the current max-height of the nextElement (if it exists)
    let currentNextElementHeight = 0;
    if (nextElement && nextElement.style.maxHeight) {
      currentNextElementHeight = parseFloat(nextElement.style.maxHeight) || 0;
    }

    // Get the scrollHeight of the current accordion container
    const containerHeight = container.scrollHeight;

    if (isOpen) {
      // Closing the accordion
      container.style.maxHeight = '0px';
      container.classList.remove('open');
      container.style.visibility = 'hidden';
      icons[0].style.display = 'inline-block';
      icons[1].style.display = 'none';
      openAccordionId = null;

      // Update nextElement's max-height by subtracting the container's height
      if (nextElement) {
        const newNextElementHeight = Math.max(0, currentNextElementHeight - containerHeight);
        nextElement.style.maxHeight = newNextElementHeight + 'px';
      }
    } else {
      // Opening the accordion
      closeAllAccordions(header);
      container.style.maxHeight = containerHeight + 'px';
      container.classList.add('open');
      container.style.visibility = 'visible';
      icons[0].style.display = 'none';
      icons[1].style.display = 'inline-block';
      openAccordionId = header.id;

      // Update nextElement's max-height by adding the container's height
      if (nextElement) {
        const newNextElementHeight = currentNextElementHeight + containerHeight;
        nextElement.style.maxHeight = newNextElementHeight + 'px';
      }
    }
  }

  // Save state before updating DOM
  saveOpenAccordionState();

  // Remove existing event listeners and clone headers
  const filterHeaders = document.querySelectorAll('.filter_header');
  filterHeaders.forEach(header => {
    const newHeader = header.cloneNode(true);
    header.parentNode.replaceChild(newHeader, header);
  });

  // Re-query headers and attach new event listeners
  const newFilterHeaders = document.querySelectorAll('.filter_header');
  newFilterHeaders.forEach(header => {
    header.removeEventListener('click', toggleAccordion);
    header.addEventListener('click', () => toggleAccordion(header));
  });

  // Restore the previously open accordion if it exists
  if (openAccordionId) {
    const headerToOpen = document.getElementById(openAccordionId);
    if (headerToOpen) {
      const container = headerToOpen.nextElementSibling || headerToOpen.closest('.js-filter')?.querySelector('.filter_container_inner');
      if (container) {
        const icons = headerToOpen.querySelectorAll('.svg-wrapper');
        if (icons.length >= 2) {
          const containerHeight = container.scrollHeight;
          container.style.maxHeight = containerHeight + 'px';
          container.style.visibility = 'visible';
          icons[0].style.display = 'none';
          icons[1].style.display = 'inline-block';

          // Restore nextElement's max-height
          if (nextElement) {
            let currentNextElementHeight = parseFloat(nextElement.style.maxHeight) || 0;
            nextElement.style.maxHeight = (currentNextElementHeight + containerHeight) + 'px';
          }
        }
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // Use event delegation to handle keydown events for filter inputs
  document.addEventListener('keydown', (event) => {
    if (
      event.target.matches('.filter_container_inner input[type="checkbox"]') &&
      event.key === 'Enter'
    ) {
      event.preventDefault();
      event.target.click();
    }
  });
});

function enableDragScroll(container) {
  let isDown = false;
  let startX;
  let scrollLeft;

  container.addEventListener('mousedown', (e) => {
    if (container.scrollWidth > container.clientWidth) {
      isDown = true;
      container.classList.add('active');
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
      e.preventDefault();
    }
  });

  container.addEventListener('mouseleave', () => {
    isDown = false;
    container.classList.remove('active');
  });

  container.addEventListener('mouseup', () => {
    isDown = false;
    container.classList.remove('active');
  });

  container.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - container.offsetLeft;
    const walk = (x - startX) * 2;
    container.scrollLeft = scrollLeft - walk;
  });
}

function handleFacetFilters() {
  const detailsElement = document.querySelector('.mobile-facets__disclosure');
  const summaryElement = detailsElement?.querySelector('summary');
  const nextElement = summaryElement?.nextElementSibling;
  const heghtElement = detailsElement?.querySelector('.mobile-facets__inner');

  if (summaryElement && nextElement && detailsElement) {
    function updateElementTag() {
      if (window.innerWidth < 769) {
        const divElement = document.createElement('div');
        divElement.className = detailsElement.className;
        divElement.innerHTML = detailsElement.innerHTML;
        detailsElement.replaceWith(divElement);
        return divElement;
      }
      return detailsElement;
    }
    
    let currentElement = updateElementTag();
    const summaryElementNew = currentElement?.querySelector('summary');
    const nextElementNew = summaryElementNew?.nextElementSibling;
    const heghtElementNew = currentElement?.querySelector('.mobile-facets__inner');
    if (window.innerWidth < 769) {
   initializeAccordion();
   }

    summaryElementNew.addEventListener('click', (event) => {
      console.log('Summary clicked');
      if (window.innerWidth < 769) {
        event.preventDefault();
        if (nextElementNew.style.maxHeight && nextElementNew.style.maxHeight !== '0px') {
          nextElementNew.style.maxHeight = '0';
           currentElement.removeAttribute("open", "");
        } else { 
          nextElementNew.style.maxHeight = heghtElementNew.scrollHeight + 'px';
          currentElement.setAttribute("open", "");
        }
      }
      event.stopImmediatePropagation();
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 768) {
        nextElementNew.style.maxHeight = 'unset';
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  handleFacetFilters();
  const containers = document.querySelectorAll('.mobile-facets__main, .facets-container-drawer .facets-pill');
  containers.forEach(container => {
    enableDragScroll(container);
  });

  document.querySelectorAll('.mobile-facets__details').forEach(element => {
    const width = element.scrollWidth;
    element.style.setProperty('--min-width', `${width}px`);
  });
});